const transcript = {
  state: () => ({
    transcript: null,
    transcriptSegments: null,
    clickedTranscriptCard: null,
    isTranscriptPlayOn: false,
    isTranscriptCardClicked: null,
  }),
  mutations: {
    setTranscript(state, payload) {
      state.transcript = payload
    },

    setTranscriptSegments(state, payload) {
      state.transcriptSegments = payload
    },

    setClickedTranscriptCard(state, payload) {
      state.clickedTranscriptCard = payload
    },

    setIsTranscriptPlayOn(state, payload) {
      state.isTranscriptPlayOn = payload
    },

    setIsTranscriptCardClicked(state, payload) {
      state.isTranscriptCardClicked = payload
    },
  },
  actions: {
    setTranscript({ commit }, payload) {
      // console.log('updateTranscript', payload)
      commit('setTranscript', payload)
    },

    setTranscriptSegments({ commit }, payload) {
      // console.log('updateTranscriptSegments', payload)
      commit('setTranscriptSegments', payload)
    },

    setClickedTranscriptCard({ commit }, payload) {
      // console.log('updateClickedTranscriptCard', payload)
      commit('setClickedTranscriptCard', payload)
    },

    setIsTranscriptPlayOn({ commit }, payload) {
      // console.log('updateIsTranscriptPlayOn', payload)
      commit('setIsTranscriptPlayOn', payload)
    },

    setIsTranscriptCardClicked({ commit }, payload) {
      // console.log('updateIsTranscriptCardClicked', payload)
      commit('setIsTranscriptCardClicked', payload)
    },
  },
  getters: {
    transcript(state) {
      return state.transcript
    },

    transcriptSegments(state) {
      return state.transcriptSegments
    },

    clickedTranscriptCard(state) {
      return state.clickedTranscriptCard
    },

    isTranscriptPlayOn(state) {
      return state.isTranscriptPlayOn
    },

    isTranscriptCardClicked(state) {
      return state.isTranscriptCardClicked
    },
  },
}

export default transcript
